<template>
  <RevContextualMenu list-class-names="transition-none" position="bottom-end">
    <template #trigger="{ show, hide, isOpen }">
      <CountrySwitchMenuButton
        :compact
        :countryCode="thisMarket.countryCode"
        data-test="country-switch-menu-header"
        :isOpen
        trackingSpot="header"
        @click="isOpen ? hide() : show()"
      />
    </template>

    <template #items="{ hide }">
      <div class="text-static-default-hi py-8">
        <div class="flex items-center px-24">
          <CountrySwitchMenuHeader @click="hide" />
        </div>
        <ClientOnly v-if="!isHomePage">
          <CountrySwitchMenuSearchList variant="compact" />
        </ClientOnly>
        <CountrySwitchMenuSearchList v-else variant="compact" />
      </div>
    </template>
  </RevContextualMenu>
</template>

<script setup lang="ts">
import { useRoute } from '#imports'
import { computed } from 'vue'

import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'
import { RevContextualMenu } from '@ds/components/ContextualMenu'

import { HOME } from '~/scopes/home/route-names'

import CountrySwitchMenuButton from './CountrySwitchMenuButton.vue'
import CountrySwitchMenuHeader from './CountrySwitchMenuHeader.vue'
import CountrySwitchMenuSearchList from './CountrySwitchMenuSearchList.vue'

defineProps<{
  compact?: boolean
}>()

const thisMarket = useMarketplace().market
const route = useRoute()
const isHomePage = computed(() => route.name === HOME)
</script>
